import React from "react";
import { Link } from "react-router-dom";
import ProductGrid from "./ProductGrid";
import { ALL_PRODUCTS } from "./data/products";
import SiteLogo, { LOGO_ALT } from "./components/SiteLogo";
import SiteNav from "./components/SiteNav";
import usePageTitle from "./usePageTitle";

export default function CollectionPage() {
  usePageTitle("Collection");
  return (
    <div className="collection-page">
      <SiteNav />

      <section className="collection-page__hero" id="collection-top">
        <div className="products-header reveal visible">
          <h1 className="section-title">
            Full <em>Collection</em>
          </h1>
          <div className="section-divider" />
          <p className="collection-page__lede">
            Every piece is made to order in our studio. Tap Enquire to share your idea — we will help you choose finishes,
            colors, and sizing.
          </p>
        </div>
        <ProductGrid products={ALL_PRODUCTS} />
      </section>

      <footer className="collection-page__footer">
        <Link to="/" className="collection-page__footer-logo" aria-label={`${LOGO_ALT} — Home`}>
          <SiteLogo variant="footer" />
        </Link>
        <Link to="/" className="btn-enquire">
          ← Back to home
        </Link>
        <a href="/#custom" className="btn-primary" data-custom-order="true">
          <span>Request a custom order</span>
        </a>
      </footer>
    </div>
  );
}
